import request from '@/util/http'


// Excel下载模板
export const downloadTemplate=(type)=>{
    return `/admin/excel/download?type=${type}`;
}

// Excel导出
export const excelExport=(type)=>{
    return `/admin/excel/export?type=${type}`;
}

// Excel导入
export const excelImport=(type,param)=>request({
    headers:{
        "Content-Type": "multipart/form-data"
    },
    url: `/admin/excel/import?type=${type}`,
    method: 'post',
    data: param
});
